export default function hideDialog(req: { value?: { setDialogHidden: boolean }, setDialogHidden?: boolean }): void {
    const isHidden = req?.value?.setDialogHidden || req?.setDialogHidden;
    const dialog = document.querySelector<HTMLElement>('.dialog-root');
    if (isHidden && dialog) {
        dialog.style.opacity = '0';
    } else if (dialog) {
        dialog.style.opacity = '1';
    }
}
